'use strict';

angular.module('ClinicApp').config(function($stateProvider, authorizationProvider) {
  $stateProvider.state('doctor', {
    url: '/doctor/:id/',
    templateUrl: '/views/doctor.html',
    controller: 'DoctorCtrl',
    params: {
      click: null,
    },
    resolve: {
      auth: authorizationProvider.requireAuthorizedUser,
      doctor: function($stateParams, $q, DoctorService, CurrentUser) {
        var deferred = $q.defer();

        DoctorService.getDoctor($stateParams.id).then(function(doctor) {
          CurrentUser.hasPermission('Doctor', doctor.id)
            .then(function() {
              deferred.resolve(doctor);
            })
            .catch(function() {
              angular.forEach(doctor.providers, function(provider) {
                if (CurrentUser.hasPermissionNonPromise('Clinic', provider.clinic.id)) {
                  deferred.resolve(doctor);
                }
              });
              deferred.reject();
            });
        });

        return deferred.promise;
      },
      pageTitle: function($pageTitle, doctor) {
        $pageTitle.set(doctor.name + ' - Opencare');
      },
    },
  });
});

angular.module('ClinicApp').controller('DoctorCtrl', function(doctor, $scope, $state, $stateParams, DoctorService, OCCDoctorUtil) {
  $scope.doctor = doctor;
  $scope.navigationTabs = [{
    label: 'Insurance',
    state: 'insurance',
    iconClassName: 'fa-list-alt',
    available: OCCDoctorUtil.isInsuranceAvailable($scope.doctor),
  }, {
    label: 'Profile',
    state: 'profile',
    iconClassName: 'fa-building-o',
    available: true,
  }];

  $scope.$on('reloadDoctor', function() {
    return DoctorService.getDoctor($stateParams.id).then(function(doctor) {
      $scope.doctor = doctor;
      $scope.insuranceTabAvailable = OCCDoctorUtil.isInsuranceAvailable($scope.doctor);
    });
  });

  $scope.isCurrentState = function(stateName) {
    return $state.is(stateName);
  };

  $scope.currentTabName = function() {
    return $state.current.name.split('.')[1];
  };

  // Default active tab.
  if ($scope.isCurrentState('doctor')) {
    if (
      (!$scope.doctor.metadata || !$scope.doctor.metadata.setupWizardComplete)
      && !($scope.doctor.name && $scope.doctor.canonicalPath)
    ) {
      $state.go('doctor-setup', {
        id: $scope.doctor.id,
        step: 1,
      }, {
        location: 'replace',
      });
    } else {
      $state.go('doctor.profile', null, {
        location: 'replace',
      });
    }
  }
});
